import React from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";
import "swiper/css/pagination";
import "swiper/css";

function Testimonials() {
  const clients = [
    {
      img: profilePic1,
      name: "Camille R.",
      role: "Cheffe de projet",
      review:
        "Superbe collaboratrice, je recommande fortement. Assidue, motivée et toujours force de proposition.",
    },
    {
      img: profilePic2,
      name: "Julien M.",
      role: "Développeur senior",
      review:
        "Je recommande fortement. Assidue, motivée et passionnée par son travail.",
    },
    {
      img: profilePic3,
      name: "Sarah L.",
      role: "Product owner",
      review: "Superbe collaboratrice, je recommande fortement.",
    },
    {
      img: profilePic4,
      name: "Nicolas P.",
      role: "Designer UI",
      review:
        "Je recommande fortement. Assidue, fiable et très investie dans ses missions.",
    },
  ];

  return (
    <section className="t-wrapper section" id="Témoignages">
      <div className="container">
        <div className="t-heading section-heading">
          <span>Les clients obtiennent toujours</span>
          <span className="accent">un travail exceptionnel</span>
          <p className="section-copy">De ma part…</p>
          <div className="blur t-blur1" style={{ background: "var(--purple)" }} />
          <div className="blur t-blur2" style={{ background: "skyblue" }} />
        </div>

        <Swiper
          modules={[Pagination]}
          slidesPerView={1}
          spaceBetween={24}
          pagination={{ clickable: true }}
          className="testimonials-slider"
        >
          {clients.map((client) => (
            <SwiperSlide key={client.name}>
              <article className="testimonial">
                <img src={client.img} alt={client.name} />
                <div className="testimonial-stars" aria-label="5 étoiles">
                  ★★★★★
                </div>
                <p>{client.review}</p>
                <div className="testimonial-meta">
                  <strong>{client.name}</strong>
                  <span>{client.role}</span>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;
